import { ChangeEvent } from "react";
import { Box, Divider, Grid, InputAdornment, MenuItem, Typography } from "@mui/material";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { ICreateComissaoCorretora } from "src/Contexts/comissoes/ComissoesTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";

import { AutoCompleteAdministradoras } from "../../../../../components/AutoCompleted/AutoCompleteAdministradoras";
import { AutoCompleteModalidade } from "../../../../../components/AutoCompleted/AutoCompleteModalidade";
import { AutoCompleteOperadora } from "../../../../../components/AutoCompleted/AutoCompleteOperadora";

import { InfoOutlinedIcon } from "src/Pages/components/Icons/Icons";
import { CardAlerts } from "src/Pages/components/CardAlerts/CardAlerts";
import { handleValidateParcels } from "../../../5-ComissaoProdutor/components/Form/FormularioComissaoProdutor";

export const FormComissaoCorretora = () => {
  const { valuesInputsComissaoCorretora, setValuesInputsComissaoCorretora } =
    useContextComissoes();

  const handleChange =
    (prop: keyof ICreateComissaoCorretora, option?: "limitNumber") =>
      (event: ChangeEvent<HTMLInputElement>) => {
        if (option === "limitNumber") {
          if (event.target.value.length <= 6) {
            setValuesInputsComissaoCorretora({
              ...valuesInputsComissaoCorretora,
              [prop]: event.target.value.replace(",", ""),
            });
          }
        } else {
          setValuesInputsComissaoCorretora({
            ...valuesInputsComissaoCorretora,
            [prop]: event.target.value,
          });
        }
      };

  return (
    <>
      <Typography sx={{ fontSize: "0.9rem", fontWeight: "bold", mb: "1rem" }}>
        Configure os detalhes da grade de comissão
      </Typography>

      <Grid container spacing={2} sx={{ marginBottom: "2rem" }}>
        <Grid item xs={12} md={4} sx={{ '& .MuiFormControl-root': { margin: 0, }, }}>
          <AutoCompleteOperadora
            label="Operadora *"
            fullWidth
            variant="outlined"
            placeholder="Amil, Bradesco, etc."
          />
        </Grid>
        <Grid item xs={12} md={4} sx={{ '& .MuiFormControl-root': { margin: 0, }, }}>

          <AutoCompleteAdministradoras
            label="Administradora (Opcional)"
            fullWidth
            variant="outlined"
            placeholder="QualiCorp, etc."
          />
        </Grid>

        <Grid item xs={12} md={4} sx={{ '& .MuiFormControl-root': { margin: 0, }, }}>
          <AutoCompleteModalidade
            label="Modalidade *"
            fullWidth
            variant="outlined"
            placeholder="PME, ADESÃO, etc."
          />
        </Grid>

        <Grid item xs={12} md={4} sx={{ '& .MuiFormControl-root': { margin: 0, }, }}>
          <AppTextField
            label="Vigência *"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            type="date"
            fullWidth
            variant="outlined"
            value={valuesInputsComissaoCorretora?.date_vigencia}
            onChange={handleChange("date_vigencia")}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: "1.4rem" }} />

      <Typography sx={{ fontSize: "0.9rem", mb: "1rem", fontWeight: "bold" }}>
        Selecione as parcelas que geram comissões e defina suas porcentagens.
      </Typography>

      <Grid container spacing={2} sx={{ marginBottom: "2rem" }}>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="1 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_1}
            onChange={handleChange("parc_1", "limitNumber")}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="2 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_2}
            onChange={handleChange("parc_2", "limitNumber")}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="3 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_3}
            onChange={handleChange("parc_3", "limitNumber")}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="4 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_4}
            onChange={handleChange("parc_4", "limitNumber")}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="5 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_5}
            onChange={handleChange("parc_5", "limitNumber")}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="6 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_6}
            onChange={handleChange("parc_6", "limitNumber")}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="7 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_7}
            onChange={handleChange("parc_7", "limitNumber")}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="8 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_8}
            onChange={handleChange("parc_8", "limitNumber")}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="9 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_9}
            onChange={handleChange("parc_9", "limitNumber")}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="10 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_10}
            onChange={handleChange("parc_10", "limitNumber")}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="11 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_11}
            onChange={handleChange("parc_11", "limitNumber")}
          />
        </Grid>
        <Grid item xs={4} sm={2}>
          <AppTextField
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
            label="12 Parcela"
            variant="outlined"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            fullWidth
            type="text"
            value={valuesInputsComissaoCorretora?.parc_12}
            onChange={handleChange("parc_12", "limitNumber")}
          />
        </Grid>
      </Grid>

      {
        handleValidateParcels([
          valuesInputsComissaoCorretora.parc_1,
          valuesInputsComissaoCorretora.parc_2,
          valuesInputsComissaoCorretora.parc_3,
          valuesInputsComissaoCorretora.parc_4,
          valuesInputsComissaoCorretora.parc_5,
          valuesInputsComissaoCorretora.parc_6,
          valuesInputsComissaoCorretora.parc_7,
          valuesInputsComissaoCorretora.parc_8,
          valuesInputsComissaoCorretora.parc_9,
          valuesInputsComissaoCorretora.parc_10,
          valuesInputsComissaoCorretora.parc_11,
          valuesInputsComissaoCorretora.parc_12
        ]) && (
          < CardAlerts
            title="Parcelas zeradas não geram comissão de recebimento !"
            subTitle="Todas as parcelas que não forem preenchidas serão consideradas como 0% (Zero)"
            color="primary"
            icon={<InfoOutlinedIcon fontSize="small" />}
          />
        )
      }

      <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1.5rem" }}>
        <InfoOutlinedIcon fontSize="small" />
        <Typography sx={{ fontSize: "0.8rem", }}>
          Se a comissão for vitalícia, defina qual parcela ela passa ser vitalícia.
        </Typography>
      </Box>


      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <AppTextField
            label="Vitalícia começa na parcela "
            fullWidth
            variant="outlined"
            select
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsComissaoCorretora?.vitalicio}
            onChange={handleChange("vitalicio")}
          >
            <MenuItem value="NONE" sx={{ fontSize: "0.75rem" }}>Nenhuma parcela</MenuItem>
            <MenuItem value="1" sx={{ fontSize: "0.75rem" }}>Começa na 1ª parcela</MenuItem>
            <MenuItem value="2" sx={{ fontSize: "0.75rem" }}>Começa na 2ª parcelas</MenuItem>
            <MenuItem value="3" sx={{ fontSize: "0.75rem" }}>Começa na 3ª parcelas</MenuItem>
            <MenuItem value="4" sx={{ fontSize: "0.75rem" }}>Começa na 4ª parcelas</MenuItem>
            <MenuItem value="5" sx={{ fontSize: "0.75rem" }}>Começa na 5ª parcelas</MenuItem>
            <MenuItem value="6" sx={{ fontSize: "0.75rem" }}>Começa na 6ª parcelas</MenuItem>
            <MenuItem value="7" sx={{ fontSize: "0.75rem" }}>Começa na 7ª parcelas</MenuItem>
            <MenuItem value="8" sx={{ fontSize: "0.75rem" }}>Começa na 8ª parcelas</MenuItem>
            <MenuItem value="9" sx={{ fontSize: "0.75rem" }}>Começa na 9ª parcelas</MenuItem>
            <MenuItem value="10" sx={{ fontSize: "0.75rem" }}>Começa na 10ª parcelas</MenuItem>
            <MenuItem value="11" sx={{ fontSize: "0.75rem" }}>Começa na 11ª parcelas</MenuItem>
            <MenuItem value="12" sx={{ fontSize: "0.75rem" }}>Começa na 12ª parcelas</MenuItem>
          </AppTextField>
        </Grid>
      </Grid>
    </>
  );
};
